import * as types from './mutation-types';
import { defaultState } from './state';

const resetState_ = state => {
	Object.assign(state, defaultState);
};
export default {
	resetState_,
	[types.DEFAULT_ASSIGN]: (state, payload) => {
		state[payload.key] = payload.value;
	},
	[types.SEARCH_PARAM]: (state, payload) => {
		state.searchParams[payload.key] = payload.value;
	},

	[types.TREE_LIST]: (state, payload) => {
		// 2022-03-07
		const { menus } = payload;

		const makeTree = menuItemList => {
			if (!Array.isArray(menuItemList) || (Array.isArray(menuItemList) && menuItemList.length === 0)) return [];
			else {
				return menuItemList.map(menuItem => {
					const { scrName, menuItemList } = menuItem;
					return { ...menuItem, label: scrName, children: makeTree(menuItemList) };
				});
			}
		};

		const children = menus.map(menu => {
			const { scrName, menuItemList } = menu;
			return { ...menu, label: scrName, children: makeTree(menuItemList) };
		});

		state.menuTree = [
			{
				label: 'Root',
				children
			}
		];
	}
};
